import ru from '../langs/ru.json'
import en from '../langs/en.json'
import es from '../langs/esp.json'
import Cookies from 'js-cookie';

import {
    CHANGE_LANG,
    CHANGE_MENU_ITEM,
    CHANGE_MENU_SUBITEM,
    HIDE_404,
    HIDE_LOADER,
    MAIN_REQUEST, MOBILE_LANG, MOBILE_POPUP, QAA_CLICK,
    SHOW_404,
    SHOW_LOADER, SUMMARY_POPUP, SUMMARY_REQUEST,
    TABLE_REQUEST,
    GET_ERROR_ALERT, CLOSE_ERROR_ALERT,
    CODE_POPUP, SET_CODE,
    SHOW_CODE_LOADER, HIDE_CODE_LOADER,
    SET_GROUP,
    LOGIN_POPUP,
    SET_TOKEN, SHOW_LOGIN_LOADER, HIDE_LOGIN_LOADER,
    SET_SELECTED_GIFT, CONFIRM_SPIN_POPUP, CONFIRM_GIFT_POPUP, CONFIRM_POPUP_LOADING,
} from "./types";

let language = Cookies.get('locale')
if (typeof language === 'string') {
    language = language.toString().toUpperCase();
}
if (!(language === 'RU' || language === 'EN' || language === 'ES')) {
    language = window.navigator ? (window.navigator.language || window.navigator.systemLanguage || window.navigator.userLanguage) : "ru";
    language = language.substr(0, 2).toUpperCase();
}
const initialState = {
    loading: false,
    is404: false,
    group: false,
    mainRequest: false,
    tableRequest: false,
    summaryRequest: false,
    menuItem: 'conditionals',
    menuSubitem: 'gifts',
    currentLangName: language === 'ES' ? 'ES' : language === 'EN' ? 'EN' : 'RU',
    currentLang: language === 'ES' ? es : language === 'EN' ? en : ru,
    langs: [{ name: 'RU', lang: ru }, { name: 'EN', lang: en }, { name: 'ES', lang: es }],
    qaa: null,
    summaryPopup: false,
    mobilePopup: false,
    mobileLang: false,
    isMobile: window.innerWidth < 992 ? true : false,
    alert: {
        isShow: null,
        text: null
    },
    codePopupLoading: null,
    codePopup: null,
    code: '',
    loginPopupLoading: null,
    loginPopup: null,
    token: '',
    //confirmGiftPopupLoading: null,
    //confirmGiftPopup: null,
    selectedGift: null,
    confirmPopupLoading: null,
    confirmSpinPopup: null,
    confirmGiftPopup: null,
}

export const appReducer = (state = initialState, action) => {
    switch (action.type) {
        case SHOW_LOADER:
            return { ...state, loading: true }
        case HIDE_LOADER:
            return { ...state, loading: false }
        case SHOW_404:
            return { ...state, is404: true }
        case HIDE_404:
            return { ...state, is404: false }
        case MAIN_REQUEST:
            return { ...state, mainRequest: true }
        case TABLE_REQUEST:
            return { ...state, tableRequest: true }
        case SUMMARY_REQUEST:
            return { ...state, summaryRequest: true }
        case CHANGE_MENU_ITEM:
            return { ...state, menuItem: action.payload }
        case CHANGE_MENU_SUBITEM:
            return { ...state, menuSubitem: action.payload }
        case QAA_CLICK:
            return { ...state, qaa: action.payload }
        case CHANGE_LANG:
            return {
                ...state,
                currentLangName: action.payload.currentLangName,
                currentLang: action.payload.currentLang,
                mobileLang: false
            }
        case MOBILE_POPUP:
            return { ...state, mobilePopup: action.payload }
        case SET_TOKEN:
            return { ...state, token: action.payload }
        case LOGIN_POPUP:
            return { ...state, loginPopup: action.payload }
        case SHOW_LOGIN_LOADER:
            return { ...state, codePopupLoading: true }
        case HIDE_LOGIN_LOADER:
            return { ...state, codePopupLoading: false }
        case MOBILE_LANG:
            return { ...state, mobileLang: action.payload }
        case SUMMARY_POPUP:
            return { ...state, summaryPopup: action.payload }
        case GET_ERROR_ALERT:
            return { ...state, alert: { isShow: true, text: action.payload } }
        case CLOSE_ERROR_ALERT:
            return { ...state, alert: { ...state.alert, isShow: false } }
        case CODE_POPUP:
            return { ...state, codePopup: action.payload }
        case SET_CODE:
            return { ...state, code: action.payload }
        case SHOW_CODE_LOADER:
            return { ...state, codePopupLoading: true }
        case HIDE_CODE_LOADER:
            return { ...state, codePopupLoading: false }
        case SET_GROUP:
            return { ...state, group: action.payload }
        case SET_SELECTED_GIFT:
            return { ...state, selectedGift: action.payload }
        case CONFIRM_SPIN_POPUP:
            return { ...state, confirmSpinPopup: action.payload }
        case CONFIRM_GIFT_POPUP:
            return { ...state, confirmGiftPopup: action.payload }
        case CONFIRM_POPUP_LOADING:
            return { ...state, confirmPopupLoading: action.payload }
        default:
            return state
    }
}